/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import RegisteredParticipant from './registered_participant'
import PaymentMethod from './payment_method'
import Groups from './groups'
import Polls from './polls'
import Responses from './responses'
import Live from './mixins/_live'
import Person from './mixins/_person'
import { rootKey } from '../util'
import _ from 'underscore'
import Backbone from '@polleverywhere/backbone'
import URI from 'urijs'

export default class User extends RegisteredParticipant {
  get defaults () {
    return { role: 'presenter' }
  }

  get modelProperties () {
    return super.modelProperties.concat([
      'login'
    ])
  }

  url () {
    /*
     * TODO: remove these conditionals when we split out /my/profile
     * and participant and user
     */
    if (this.isNew()) {
      return '/users'
    } else {
      return '/my/profile'
    }
  }

  initialize (opts) {
    // bind to their pollev stream
    this.include(Live)
    this.include(Person)

    // Set up associations.
    this.paymentMethod = new PaymentMethod()

    this.groups = new Groups()
    this.groups.user = this

    this.polls = new Polls()
    this.polls.user = this

    this.responses = new Responses()
  }

  /*
   * Clears payment method, responses, groups, users, and model properties
   *
   */
  clear () {
    super.clear(...arguments)
    this.paymentMethod.clear()
    this.responses.reset()
    this.groups.reset()
    return this.polls.reset()
  }

  liveChannel () {
    return URI('users').segment(this.get('login')).segment('activity/current.json').toString()
  }

  liveParams () {
    const params = {}
    if (this.firehose_token) {
      params.firehose_token = this.firehose_token
    }
    return params
  }

  livePreflight () {
    return Backbone.ajax({
      dataType: 'json',
      url: '/api/firehose_tokens/current_activity',
      type: 'GET',
      data: {
        presenter: this.get('login')
      }
    }).done(data => {
      this.firehose_token = data.firehose_token
    })
  }

  /*
   * Makes a PUT request to /profile/read_announcement to dismiss notifications
   *
   */
  dismissAnnouncement () {
    return this.sync('update', this, {
      url: '/profile/read_announcement',
      type: 'PUT'
    }
    )
  }

  /*
   * Returns <first name> <last initial>.
   *
   * @return [String]
   *
   */
  firstNameLastInitial () {
    const firstName = this.get('first_name')
    const lastName = this.get('last_name')
    const lastInitial = (lastName || '').slice(0, 1)

    return `${firstName} ${lastInitial}.`
  }

  /*
   * Checks if registered with user
   *
   * @return [Boolean] true when success
   *
   */
  isRegisteredWith (obj) {
    let accountId
    if (_.isNumber(obj)) {
      accountId = obj
    } else {
      accountId = obj.get('account_id')
    }

    const membershipAccountIds = this.get('member_of_account_ids')

    return _.include(membershipAccountIds, accountId)
  }

  isOwner () {
    return this.get('role') === 'account owner'
  }

  isAdmin () {
    return this.get('role') === 'account administrator'
  }

  /*
   * Checks if the model is owned by this user
   *
   * @param [Model] model Any model that is associated with a user. If a number is provided, it will be considered an ID and compared to.
   * @return [Boolean] true when success
   *
   */
  owns (model) {
    let ownerId
    if (_.isUndefined(this.get('id'))) { return false }

    if (_.isNumber(model)) {
      ownerId = model
    } else {
      ownerId = (model.presenter && model.presenter.get('id')) ||
          model.get('owner_id') || model.get('user_id')
    }

    return ownerId === this.get('id')
  }

  /*
   * Checks if the model can be managed by this user.
   * Account owner and account administrators can manage all models.
   *
   * @param [Model] model Any model that is associated with a user.
   * @return [Boolean] true when success
   */
  canManage (model) {
    return this.owns(model) || ((this.isAdmin() || this.isOwner()) && (model.get('account_id') === this.get('account_id')))
  }

  hasLogin () {
    return this.get('login').length > 0
  }

  hasParticipantReporting () {
    return this.get('participant_reporting')
  }

  phoneNumber () {
    return this.get('phone_number')
  }

  /*
   * True if the phone number is verified.
   * False if there is no phone number, or if it is not verified.
   */
  isPhoneNumberVerified () {
    return this.phoneNumber() && (this.phoneNumber() === this.get('phone_number'))
  }

  toJSON () {
    // Temporary
    if (this.isNew()) {
      return rootKey('user', this.attributes)
    } else {
      return super.toJSON(...arguments)
    }
  }

  parse (data) {
    if (data == null) { data = {} }
    let obj = data

    /*
     * Temporary
     * Pop the root key if available
     */
    if (data.user != null) { obj = data.user }

    // Set payment method if its included
    if (obj.payment_method_id != null) { this.paymentMethod.set({ id: obj.payment_method_id }) }

    return obj
  }

  static sendPasswordReset (email) {
    return Backbone.ajax({
      type: 'POST',
      url: '/api/password_resets',
      data: {
        email
      }
    })
  }

  // Login flow check to see if the user exists and if they need to use SSO.
  // This endpoint should be used in place of checkForExistence or samlAjax,
  // both of which are deprecated.
  static check (loginOrEmail) {
    return Backbone.ajax({
      url: '/api/users/check',
      data: { login_or_email: loginOrEmail },
      ssl: true
    })
  }

  // Deprecated
  static checkForExistence (identifier) {
    return Backbone.ajax({
      type: 'HEAD',
      url: `/api/users/search?login_or_email=${encodeURIComponent(identifier)}`,
      ssl: true
    })
  }

  // Deprecated
  static samlAjax (loginValue) {
    return Backbone.ajax({
      url: '/saml_check.json',
      data: {
        email_login: loginValue
      },
      ssl: true
    })
  }
}
